/**
 * Helpers for the LinkedIn `multiImage.urls` union.
 *
 * The schema accepts both bare URL strings (legacy callers from before
 * Phase 3.5) and `{ url, altText }` objects. Consumers should normalize
 * with these helpers instead of sprinkling typeof checks.
 *
 * Kept in its own file with **zero backend-only imports** so that frontend
 * code can value-import these helpers without dragging the whole
 * `createPost.ts` module (and its `env`/`axios`/`logger` imports) into
 * the browser bundle.
 */

export type MultiImageEntry = string | { url: string; altText?: string }

export const multiImageEntryUrl = (e: MultiImageEntry): string =>
  typeof e === 'string' ? e : e.url

export const multiImageEntryAltText = (e: MultiImageEntry): string | undefined =>
  typeof e === 'string' ? undefined : e.altText
